import { Address } from "../../../../../../interfaces/interfaces";
import LoadingSpinner from "../../../../../../components/LoadingSpinner/LoadingSpinner";
import usePrimaryAddress from "./hooks/usePrimaryAddress";
import PrimaryAddressSelector from "./PrimaryAddressSelector";
import AddressDetail from "./AddressDetails";
import NZPostAddressSelector from "./NZPostAddressSelector";

interface Props {
  updateShippingAddressInRedux: (a: Address | null) => void;
  clearShippingAddressInRedux: () => void;
}

const PrimaryAddress = ({
  updateShippingAddressInRedux,
  clearShippingAddressInRedux,
}: Props) => {
  const {
    isLoading,
    isPostLoading,
    errorMessage,
    primaryAddresses,
    listNZPostAddresses,
    selectedPrimaryAddress,
    selectedNZPostAddress,
    onAddressSelect,
    onNZPostChange,
  } = usePrimaryAddress({
    updateShippingAddressInRedux,
    clearShippingAddressInRedux,
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="addressTableWrapper">
      <table className="addressTable">
        <tbody>
          <PrimaryAddressSelector
            addresses={primaryAddresses}
            addressSelected={selectedPrimaryAddress}
            onChange={onAddressSelect}
            isLoading={isPostLoading}
          />
          {selectedPrimaryAddress && (
            <AddressDetail address={selectedPrimaryAddress} />
          )}
          {!isLoading && !isPostLoading && (
            <NZPostAddressSelector
              postAddresses={listNZPostAddresses}
              selected={selectedNZPostAddress}
              onChange={onNZPostChange}
            />
          )}
        </tbody>
      </table>
      {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
    </div>
  );
};

export default PrimaryAddress;
